var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "导入发货",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            { attrs: { type: "warning", "show-icon": "", closable: false } },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("\n\t\t\t\t温馨提示："),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t字段需包含：订单编号，物流公司名称、物流公司编码、物流单号\n\t\t\t"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex", staticStyle: { "margin-top": "20px" } },
            [
              _c("div", [_vm._v("模版下载：")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: { click: _vm.downModal },
                },
                [_vm._v("模版文件")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex", staticStyle: { "margin-top": "20px" } },
            [
              _c("div", { staticStyle: { height: "43px" } }, [
                _vm._v("文件选择："),
              ]),
              _vm._v(" "),
              _c("UploadFile", {
                attrs: { accept: ".xlsx, .xls" },
                model: {
                  value: _vm.uploadFiles,
                  callback: function ($$v) {
                    _vm.uploadFiles = $$v
                  },
                  expression: "uploadFiles",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitImport } },
                [_vm._v("确认导入")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }